import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const partialOrTotalDeafness: AnswerPathTreeNode = {
  path: 'partialOrTotalDeafness',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredPartialOrTotalDeafnessDetails }],
};
